export const getList = (state) => state.list;
export const getTags = (state) => [
  {
    id: null,
    name: '全て',
    color: null
  },
  ...state.list
];
export const getLsTags = (state) => state.lsTags;
